import { render, staticRenderFns } from "./addTopic.vue?vue&type=template&id=3d3fcac0&scoped=true"
import script from "./addTopic.vue?vue&type=script&lang=js"
export * from "./addTopic.vue?vue&type=script&lang=js"
import style0 from "./addTopic.vue?vue&type=style&index=0&id=3d3fcac0&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3fcac0",
  null
  
)

export default component.exports